module.exports = __webpack_public_path__ + "static/media/food4.8c86b44d.jpg";